export const COOKIE_REFRESH_TOKEN = 'refresh-token';
export const COOKIE_ACCESS_TOKEN = 'access_token';
